import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";

class HolidayCard extends Component {
  render() {
    return (
      <div className="shadow-sm border rounded p-3">
        <Accordion defaultActiveKey={null}>
          <div>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="1"
              style={{
                padding: 0,
                textDecoration: "none",
                boxShadow: "none",
                width: "100%",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="th-12 th-black text-left th-medium">
                    {this.props.title}
                  </div>
                  <div className="th-12 th-grey text-left">
                    {this.props.dateDiff}
                  </div>
                </div>
                <i
                  className="fa fa-angle-down th-primary"
                  aria-hidden="true"
                ></i>
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <div className="mt-2">
                <div className="th-12 th-grey text-left">
                  No of Days: {this.props.days}
                </div>
                <div className="th-12 th-grey text-left">
                  {this.props.description}
                </div>
              </div>
            </Accordion.Collapse>
          </div>
        </Accordion>
      </div>
    );
  }
}
export default HolidayCard;
